import { createContext } from 'react'


export const RestaurantContext = createContext({
    places: [],
    current: -1, 
    setCurrent(v) {         //если тыкнули в ресторан
        this.current = v    // запоминаем куда тыкнули
        const p = this.places?.[this.current] //проверяем есть ли такой в places
        if (!p) { 
            this.current = -1 //если нет, сбрасываем в начальные значения
            return
        }
        console.log(p)
    },
})
